import Component from '../core/Component'
import ScrollService, {scrollToElement} from '../services/Scroll'

export default class FooterBottomLinks extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                if(window.location.href === link.href) {
                    scrollToElement(document.querySelector('#swup'))
                }
            })
        })
    }
}